const branch = process.env.GIT_BRANCH;

const baseUrl =
    branch === 'main'
        ? 'https://embark-api-prd.azurewebsites.net'
        : branch === 'qa'
        ? 'https://embark-api-qa.azurewebsites.net'
        : 'https://embark-api-prd.azurewebsites.net';

        export default {
    baseUrl,
    baseCononicalUrl: process.env.SITE_URL || 'https://www.apsy.io',
    mailChimpId: branch === 'main' ? 'eca8ee8ba4' : '1fa9334d88'
    // mailChimpId: 'eca8ee8ba4'
};
